import { RootState } from '@/store/types';
import axios from 'axios';
import { AxiosCacheInstance, setupCache } from 'axios-cache-interceptor';
import Vue from 'vue';
import { Store } from 'vuex';
import { addRequestInterceptors } from './http-interceptors-global';
import { addAddressRepositoryResponseInterceptors } from './http-response-interceptors-address-repository';

declare module 'vue/types/vue' {

  interface Vue {
    $addressRepository: AxiosCacheInstance
  }

  interface VueConstructor {
    $addressRepository: AxiosCacheInstance
  }
}

export function AddressRepositoryAxios(vueCtor: typeof Vue, store: Store<RootState>): void {
  const axiosInstance = axios.create({
    baseURL: vueCtor.$settings.addressApiUrl,
    headers: {
      'Ocp-Apim-Subscription-Key': vueCtor.$settings.subkey
    }
  })
  const addressRepository = setupCache(axiosInstance, {
    ttl: 60 * 60 * 1000,
    cachePredicate: {
      // No cache by default
      statusCheck: () => false
    },
  })

  addRequestInterceptors(addressRepository, store)
  addAddressRepositoryResponseInterceptors(addressRepository, store)

  vueCtor.prototype.$addressRepository = addressRepository
}
